export const validation =  {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  blockTitleMaxChar: 20,
  features: {
    min: 1,
    max: 2
  }
}